import { Switch } from "react-router-dom";

import MiddlewareRoute from "../Middleware";
import { CustumerManagementContextProvider } from "../../pages/customerManagements/contexts/CustomerManagementContext";
import CustomerManagementList from "../../pages/customerManagements/CustomerManagementList";
import { ModalAddressContextProvider } from "../../pages/customerManagements/contexts/ModalAddressContext";
import { ModalUserContextProvider } from "../../pages/customerManagements/contexts/ModalUserContext";
import { GlobalVariables } from "../../GlobalVariables";
import { CustomerManagementEdit } from "../../pages/customerManagements/CustomerManagementEdit";
import { DashboardViewContextProvider } from "../../pages/dashboard/contexts/DashboardViewContext";
import { ConfigureERP } from "../../pages/customerManagements/children/ConfigureERP";
import { ConfigureERPContextProvider } from "../../pages/customerManagements/contexts/ConfigureERPContext";
import { ModalCurrentUserContextProvider } from "../../pages/currentUser/contexts/ModalCurrentUserContext";
import { ManagementContextProvider } from "../../pages/accessProfile/contexts/ManagementContext";

export default function CustomerManagement() {
  return (
    <CustumerManagementContextProvider>
      <Switch>
        <MiddlewareRoute
          routePermissionId={GlobalVariables.PERMISSIONS.CLIENTES}
          path="/customermanagement/list"
          component={CustomerManagementList}
          sidebar
          noPaddingSidebar
        />
      </Switch>

      <ModalAddressContextProvider>
        <ModalUserContextProvider>
          <Switch>
            <MiddlewareRoute
              routePermissionId={
                GlobalVariables.PERMISSIONS.CLIENTES_MANAGEMENT
              }
              path="/customermanagement/create"
              component={CustomerManagementEdit}
              sidebar
              noPaddingSidebar
            />
          </Switch>
        </ModalUserContextProvider>
      </ModalAddressContextProvider>

      <DashboardViewContextProvider>
        <ModalCurrentUserContextProvider>
          <ManagementContextProvider>
            <Switch>
              <MiddlewareRoute
                routePermissionId={
                  GlobalVariables.PERMISSIONS.CLIENTES_MANAGEMENT
                }
                path="/customermanagement/edit"
                component={CustomerManagementEdit}
                sidebar
                noPaddingSidebar
              />
            </Switch>
          </ManagementContextProvider>
        </ModalCurrentUserContextProvider>
      </DashboardViewContextProvider>

      <ConfigureERPContextProvider>
        <Switch>
          <MiddlewareRoute
            routePermissionId={GlobalVariables.PERMISSIONS.CLIENTES_MANAGEMENT}
            path="/customermanagement/configure-erp"
            component={ConfigureERP}
            sidebar
            noPaddingSidebar
          />
        </Switch>
      </ConfigureERPContextProvider>
    </CustumerManagementContextProvider>
  );
}
